<template>
  <div style="display:inline;">
    <template v-if="!showTable">
      <Upload
        :before-upload="beforeUpload"
        multiple
        action=""
        type="drag"
        accept=".xls,.xlsx"
        :show-upload-list="false"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>{{ $t("checkFile") }}</p>
        </div>
      </Upload>
      <Button type="error" @click="download" style="float:right;margin:10px 0">
        模板下载
      </Button>
    </template>
    <template v-else>
      <Table :columns="fields" :data="tableData" border height="400"></Table>
    </template>
  </div>
</template>
<script>
export default {
  inject: ["$page"],
  props: {
    url: {
      type: String
    },
    uploadFunction: {
      type: Function
    },
    close: {
      type: Function
    },
    resTable: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      showTable: false,
      tableData: [],
      fields: [
        {
          title: this.$t("order_number"),
          key: "airway_number",
          align: "center",
          width: 150
        },
        {
          title: "上传状态",
          align: "center",
          key: "status",
          width: 100,
          render(h, { row }) {
            return h(
              "span",
              {
                style: {
                  color: row.status ? "green" : "red"
                }
              },
              row.status ? "上传成功" : "上传失败"
            );
          }
        },
        {
          title: "提示信息",
          align: "center",
          key: "msg",
          minWidth: 110
        }
      ]
    };
  },
  mounted() {},
  methods: {
    download() {
      window.open(this.url);
    },
    beforeUpload(file) {
      this.uploadFiles(file);
      return;
    },
    uploadFiles(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.uploadFunction(formData).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
          duration: res.data.status ? 2 : 5
        });
        if (!this.resTable) {
          if (res.data.status) {
            this.close();
            this.$page.getList();
          }
        } else {
          this.tableData = res.data.payload;
          this.showTable = true;
        }
      });
    }
  }
};
</script>
